import { Box, Button, Typography, useTheme } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import api from '../../../service/api'
import { formatDate } from '../../../utils/utilities'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import DataLoadingSpinner from '../../common/DataLoadingSpinner'
import TryAgainMessageBlock from '../../common/TryAgainMessageBlock'
import AuditClassSessionViewer from './AuditClassSessionViewer'
import CustomTable from '../../common/custom-table/CustomTable'



const AuditClassSessionsList = () => {

    const [searchParams] = useSearchParams( { searchText: "", month: "", selectedDepartment: "all", selectedInstitute: "all", view: "tabular", sortByName: "1", sortBySubmissionsCount: "1", sortByAssignmentCount: "1" } )
    const selectedInstitute = searchParams.get( 'selectedInstitute' ) || "all"

    const [error, setError] = useState( null )
    const [classSessions, setClassSessions] = useState( [] )
    const [loading, setLoading] = useState( true )
    const [selectedClassSession, setSelectedClassSession] = useState( null )

    const { layout } = useTheme()

    const navigate = useNavigate()
    const { pathname } = useLocation()

    const columns =
        [
            { id: 2, field: "name", onCellClick: setSelectedClassSession, name: "Class Sessions", searchable: true, width: "120px", padding: "10px 20px" },
            { id: 3, field: "faculty_name", linkGetter: row => `/${window.location.pathname?.includes( 'admin' ) ? "admin" : "audit"}/faculty/${row.faculty_id}?legacy=${row.legacy_system_data}`, renderCell: row => row?.faculty_details?.name?.toLowerCase(), searchable: true, cellStyles: { textTransform: "capitalize" }, name: 'Faculty name', width: "150px", align: "left", padding: "10px 20px" },
            { id: 6, field: "department", onCellClick: setSelectedClassSession, renderCell: row => row?.faculty_details?.department_name?.toLowerCase(), cellStyles: { textTransform: "capitalize" }, searchable: true, name: 'Department', padding: "10px 20px" },
            { id: 4, field: "subject", onCellClick: setSelectedClassSession, renderCell: row => row?.subject.subject_name, searchable: true, name: "Subject", padding: "10px 20px" },
            { id: 5, field: "updated_at", onCellClick: setSelectedClassSession, align: "center", renderCell: row => formatDate( row.updated_at ), name: "Updated on", width: "180px", padding: "10px 20px" },
            { id: 7, field: "resources_count", sortable: true, dataType: "number", onCellClick: setSelectedClassSession, align: "center", name: "Resources", padding: "10px 20px" },
        ]
    const handleDialogClose = () => {
        setSelectedClassSession( null )
    }


    const getData = useCallback( async () => {
        try {
            setLoading( true )
            const { data: { data } } = await api.audit.getClassSessionsForAuditing( { institute: selectedInstitute !== "all" ? selectedInstitute : "" } )
            setClassSessions( data )
        } catch ( err ) {
            console.log( err )
            setError( err?.message?.data?.message || "Something went wrong while fetching classSessions." )
        } finally {
            setLoading( false )
        }
    }, [selectedInstitute] )

    useEffect( () => {
        getData()
    }, [getData] )


    return (
        <Box gap={layout.cardsGap} sx={{ flexShrink: 0, display: "flex", flexDirection: "column" }}>

            {selectedClassSession && <AuditClassSessionViewer classSession={selectedClassSession} handleClose={handleDialogClose} openState={Boolean( selectedClassSession )} />}

            <Box display="flex" gap="20px" alignItems="flex-end" justifyContent="space-between" >
                <Typography variant="h1" fontWeight="600" component="h2" fontSize="14px">Class Sessions</Typography>
                <Button size="small" onClick={() => navigate( `/${pathname.includes( "admin" ) ? "admin" : "audit"}/class-sessions` )} variant="contained" color='secondary' disableElevation sx={{ height: "33.5px", textTransform: "capitalize", }} >View Stats</Button>
            </Box >

            {!loading && classSessions.length > 0 && <CustomTable containerStyles={{ maxHeight: "450px" }} globalSearch="Search by study material, faculty, ID or subject" data={classSessions} columns={columns} pageSize={50} />}

            {/* Retry */}
            {error && <TryAgainMessageBlock getData={getData} err={error} loading={loading} />}

            {/* Loading */}
            {loading && <DataLoadingSpinner padding="0" waitingMessage="Loading Class sessions please wait...." />}
        </Box>
    )
}

export default AuditClassSessionsList
